import { Container, Grid } from "@material-ui/core";

import Step1 from "@/public/images/step-1.svg";
import Step2 from "@/public/images/step-2.svg";
import Step3 from "@/public/images/step-3.svg";
import Step from "./Step";

type StepConfig = {
  title: string;
  description: string;
}[];

type StepsLandingProps = {
  stepTitles: string[];
  bullets: StepConfig[];
};

export default function StepsLanding({
  stepTitles,
  bullets,
}: StepsLandingProps) {
  return (
    <Container>
      <Grid container spacing={8}>
        <Grid item xs={12} lg={4}>
          <Step
            title={stepTitles[0]}
            image={<img src={Step1} alt="Quote and Buy - Step 1" />}
            list={bullets[0]}
          />
        </Grid>

        <Grid item xs={12} lg={4}>
          <Step
            title={stepTitles[1]}
            image={<img src={Step2} alt="Quote and Buy - Step 2" />}
            list={bullets[1]}
          />
        </Grid>

        <Grid item xs={12} lg={4}>
          <Step
            title={stepTitles[2]}
            image={<img src={Step3} alt="Quote and Buy - Step 3" />}
            list={bullets[2]}
          />
        </Grid>
      </Grid>
    </Container>
  );
}
